// extracted by mini-css-extract-plugin
export default {"facetMenu":"vB-z","fixed":"wB-z","nonLayerdFacets":"xB-z","productCount":"yB-z","facetBack":"zB-z","arrow":"AB-z","facetClose":"BB-z"};